module.exports = __webpack_public_path__ + "static/media/petalsInHand.d011855f.jpg";